import React from "react";

const Icon1: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="25"
      fill="transparent"
      viewBox="0 0 28 25"
    >
      <path
        fill="currentColor"
        d="M24 9.44a4.005 4.005 0 004-4v-3h-3a3.979 3.979 0 00-2.747 1.106A6.003 6.003 0 0017 .44h-3v3a6.007 6.007 0 006 6h1v13H9v-5h1a4.005 4.005 0 004-4v-3h-3a3.98 3.98 0 00-2.747 1.106A6.004 6.004 0 003 8.44H0v3a6.007 6.007 0 006 6h1v5H0v2h28v-2h-5v-13h1zm-1-3a2.002 2.002 0 012-2h1v1a2.002 2.002 0 01-2 2h-1v-1zm-14 8a2.002 2.002 0 012-2h1v1a2.002 2.002 0 01-2 2H9v-1zm-2 1H6a4.005 4.005 0 01-4-4v-1h1a4.005 4.005 0 014 4v1zm14-8h-1a4.005 4.005 0 01-4-4v-1h1a4.005 4.005 0 014 4v1z"
      ></path>
    </svg>
  );
}

export default Icon1;
